import { Injectable } from "@angular/core";

@Injectable()
export class FingerprintService {

    public fingerprint = null;

    constructor(
    ) {
    }

    async getFingerPrint() {
        if(this.fingerprint) return;

        // @fingerprintjs sai do vendor eager (Lever 1): ~106KB só usados no
        // checkout/login, mas o import estático os punha no boot de toda visita.
        const { default: FingerprintJS } = await import("@fingerprintjs/fingerprintjs");
        let fpPromise = await FingerprintJS.load();
        let fp = fpPromise;
        let result = await fp.get();

        this.fingerprint = result.visitorId;
    }
}